const WhySection = () => {
  const stats = [
    { number: '2%', label: 'Latinas in C-Suite Positions' },
    { number: '54¢', label: 'Earned per Dollar vs White Men' },
    { number: '1 in 3', label: 'Latina-Owned Businesses Fail' },
  ];

  return (
    <section id="why" className="py-32 bg-warmWhite">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl text-charcoal mb-6 leading-tight">
            Why MasDeUna Exists
          </h2>
          <div className="w-24 h-2 bg-primary mx-auto mb-8"></div>
          <p className="font-inter text-xl text-charcoal/80 max-w-3xl mx-auto font-medium">
            The numbers don't lie. Latinas are underrepresented, underpaid, and underestimated.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white p-12 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-t-4 border-primary"
            >
              <div className="font-poppins font-black text-6xl text-primary mb-4">{stat.number}</div>
              <div className="font-inter text-lg text-charcoal font-semibold">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="bg-charcoal p-12 md:p-16 rounded-3xl">
          <div className="max-w-4xl mx-auto">
            <h3 className="font-poppins font-bold text-4xl md:text-5xl text-white mb-8 leading-tight">
              We're changing the narrative.
            </h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-primary rounded-full mt-2 flex-shrink-0"></div>
                <p className="font-inter text-xl text-white/90 font-medium">
                  <strong className="text-primary">Visibility.</strong> Latinas deserve to be seen in every boardroom, every pitch deck, every decision-making table.
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-secondary rounded-full mt-2 flex-shrink-0"></div>
                <p className="font-inter text-xl text-white/90 font-medium">
                  <strong className="text-secondary">Access.</strong> Mentorship, networks, and resources shouldn't be gatekept. We're breaking down barriers.
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-3 h-3 bg-electric rounded-full mt-2 flex-shrink-0"></div>
                <p className="font-inter text-xl text-white/90 font-medium">
                  <strong className="text-electric">Power.</strong> Economic mobility, leadership roles, and generational wealth for Latina families.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;